import { createContext } from 'utilsTS/react';

export const FormContext = createContext('Form', {
    formField: false,
    isLargeFormField: false,
});
